import { SVGProps } from 'react';

export const TwitterIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='19'
    viewBox='0 0 18 19'
    fill='none'
    {...props}>
    <path
      d='M14.863 17.492H12.2282C11.9821 17.492 11.754 17.3651 11.6198 17.1536L7.78156 11.2868L7.24926 10.4736L7.20005 10.3984L2.18079 2.7265C1.84528 2.21411 2.19868 1.51367 2.78918 1.51367H5.37931C5.62088 1.51367 5.84902 1.63585 5.9877 1.84744L9.6962 7.49321L15.4714 16.2745C15.8114 16.7916 15.458 17.492 14.863 17.492Z'
      strokeWidth='1.4'
      strokeMiterlimit='10'
    />
    <path
      d='M7.16329 10.4922L1.70703 17.0418'
      strokeWidth='1.4'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M14.4619 1.67188L9.89844 7.21593'
      strokeWidth='1.4'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
  </svg>
);
